<div class="col-md-12 mb-30" [hidden]="ExpertCalibrationEdit.id>0">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">Personnel List</h5>
      <br />
      <br />
      <div class="row">
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">Full Name</label>
          <input [(ngModel)]="Filter_title" (keyup)="Change_Filter_title()" name="Filter_title" type="text"
            class="form-control" placeholder="Type here to search...">
        </div>
        <div class="form-group col-md-6">
          <label for="exampleInputEmail1">List Type</label>
          <select class="custom-select" [(ngModel)]="Filter_person" name="SubmitPeriodDate">
            <option value="1">Active List</option>
            <option value="2">All</option>
          </select>
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-6">
          <button type="button" (click)="ReadData_Persone()" class="btn btn-info" style="margin-right: 5px;"><i
              class="fa  fa-search"></i> Search </button>
          <button routerLink="/PersonAdd" type="button" class="btn btn-success" style="margin-right: 5px;"><i
              class="fa  fa-plus-circle"></i> Add New Record </button>
          <button (click)="exportexcel()" type="button" class="btn btn-warning" style="margin-right: 5px;"><i
              class="fa   fa-file-excel-o"></i> Excel </button>
          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>
      </div>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>#</th>
              <th>Full Name</th>
              <th>National ID</th>
              <th>Behineh Employment Date</th>
              <th>Abbreviation in Behineh Farayand Azma</th>
              <th>Calibration Technician</th>
              <th>Status</th>
              <th>Date</th>
              <th>User</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Persone
            |filter:Filter_title:'fullname'
            | paginate
                    : {
                        id: 'DataList_FeildTable',
                        itemsPerPage: 50,
                        currentPage: page,
                        totalItems: (DataList_Persone|filter:Filter_title:'fullname').length
                      }
            ">
              <td>{{DataList_Persone.indexOf(item)+1}}</td>
              <td>{{item.fullname}}</td>
              <td>{{item.codemeli}}</td>
              <td>{{item.tarikh_Eshtekhdam}}</td>
              <td>{{item.almat_Ekhtesari}}</td>
              <td>
                <p *ngIf="item.expert_Calibration==0" style="color: crimson;">Not Registered</p>
                <p *ngIf="item.expert_Calibration==1" style="color: #489b39;">Inside the Laboratory</p>
                <p *ngIf="item.expert_Calibration==2" style="color: #489b39;">Outside the Laboratory</p>
                <p *ngIf="item.expert_Calibration==3" style="color: #489b39;">Inside/Outside the Laboratory</p>
              </td>
              <td>
                <p *ngIf="!item.del" style="color: #489b39;">Active</p>
                <p *ngIf="item.del" style="color: crimson;">Inactive</p>
              </td>
              <td>{{item.persianDate}}</td>
              <td>{{item.username}} </td>
              <td>
                <div class="btn-group  " role="group" aria-label="Button group with nested dropdown">
                  <div *ngIf="!item.DeletingProccess" class="btn-group" role="group">
                    <button id="btnGroupDrop1" type="button" class="btn btn-warning dropdown-toggle"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      Actions
                    </button>
                    <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                      <a class="dropdown-item" [routerLink]="['/PersonEdit',{id:item.id}]"><i class="fa fa-edit"></i>
                        Edit Personnel </a>


                      <a *ngIf="item.del==false" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-lock"></i> Inactive </a>
                      <a *ngIf="item.del==true" style="cursor: pointer;" class="dropdown-item"
                        (click)="openModal(template,item)"><i class="fa fa-unlock"></i> Active </a>
                    </div>
                  </div>

                  <div *ngIf="item.DeletingProccess">
                    <img src="assets/Loading.gif" style="width: 25px;" />
                  </div>
                </div>
              </td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_FeildTable" nextLabel="Next" previousLabel="Previous"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>

<ng-template #template>
  <div class="modal-header">
    <h4 *ngIf="Data_Seleted_Delete.del==false" class="modal-title pull-left">Deactivate Personnel
      '{{Data_Seleted_Delete.fullname}}' </h4>
    <h4 *ngIf="Data_Seleted_Delete.del==true" class="modal-title pull-left">Activate Personnel
      '{{Data_Seleted_Delete.fullname}}' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_Delete.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button *ngIf="Data_Seleted_Delete.del==false" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Deactivate <i class="fa fa-lock"></i></button>
    <button *ngIf="Data_Seleted_Delete.del==true" type="button" class="btn btn-warning"
      (click)="Delete(Data_Seleted_Delete)"> Activate <i class="fa fa-unlock"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_Delete.hide()">Close</button>
  </div>
</ng-template>

<ng-template #templateExpertCalibrationEdit>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Delete Calibration Technician Information '{{Data_Seleted_Delete.fullname}} ' </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_DeleteExpertCalibration.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-warning" (click)="DeleteExpertCalibration()"> Delete <i
        class="fa fa-remove"></i></button>
    <button type="button" class="btn btn-danger" (click)="modalRef_DeleteExpertCalibration.hide()">Close</button>
  </div>
</ng-template>

<app-ExpertCalibrationEdit *ngIf="ExpertCalibrationEdit.id>0" [innerPersonRecord]="ExpertCalibrationEdit"
  (OnBack_Expert_Calibration_Action)="OnSet_ExpertCalibrationEdit($event)">

</app-ExpertCalibrationEdit>


<table id="excel-table" style="display: none;">
  <thead>
    <tr>
      <th>#</th>

      <th>Name</th>
      <th>Last Name</th>
      <th>Gender</th>
      <th>Marital Status</th>
      <th>Place of Issue</th>
      <th>ID Document Number</th>
      <th>ID Document Serial Number</th>
      <th>National ID (without leading zero)</th>
      <th>Insurance Number</th>
      <th>Father</th>
      <th>Father Occupation</th>
      <th>Mobile Number (without leading zero)</th>
      <th>Housing</th>
      <th>Email</th>
      <th>Current Home Address</th>
      <th>Postal Code</th>
      <th>Phone</th>
      <th>Military Service Status</th>
      <th>Military Service Status Description</th>
      <th>From Date to Date</th>
      <th>Spouse Name</th>
      <th>Number of Children</th>
      <th>Spouse National ID (without leading zero)</th>
      <th>Spouse Mobile Number (without leading zero)</th>
      <th>Spouse Education</th>
      <th>Spouse Date of Birth</th>
      <th>Spouse Occupation</th>


      <th>From Year/Month 1</th>
      <th>To Year/Month 1</th>
      <th>Degree Level 1</th>
      <th>Field of Study 1</th>
      <th>Specialization 1</th>
      <th>University/Higher Education Institution 1</th>
      <th>Grade Point Average 1</th>
      <th>Upload Education Certificate 1</th>

      <th>From Year/Month 2</th>
      <th>To Year/Month 2</th>
      <th>Degree Level 2</th>
      <th>Field of Study 2</th>
      <th>Specialization 2</th>
      <th>University/Higher Education Institution 2</th>
      <th>Grade Point Average 2</th>
      <th>Upload Education Certificate 2</th>

      <th>From Year/Month 3</th>
      <th>To Year/Month 3</th>
      <th>Degree Level 3</th>
      <th>Field of Study 3</th>
      <th>Specialization 3</th>
      <th>University/Higher Education Institution 3</th>
      <th>Grade Point Average 3</th>
      <th>Upload Education Certificate 3</th>


      <th>From Year/Month 1</th>
      <th>To Year/Month 1</th>
      <th>Company/Organization Name 1</th>
      <th>Employment Type 1</th>
      <th>Position 1</th>
      <th>Reason for Leaving 1</th>
      <th>Phone 1</th>
      <th>Address 1</th>

      <th>From Year/Month 2</th>
      <th>To Year/Month 2</th>
      <th>Company/Organization Name 2</th>
      <th>Employment Type 2</th>
      <th>Position 2</th>
      <th>Reason for Leaving 2</th>
      <th>Phone 2</th>
      <th>Address 2</th>

      <th>From Year/Month 3</th>
      <th>To Year/Month 3</th>
      <th>Company/Organization Name 3</th>
      <th>Employment Type 3</th>
      <th>Position 3</th>
      <th>Reason for Leaving 3</th>
      <th>Phone 3</th>
      <th>Address 3</th>

      <th>From Year/Month 1</th>
      <th>To Year/Month 1</th>
      <th>Training Syllabus 1</th>
      <th>Training Course Title 1</th>
      <th>Duration (Hours) 1</th>
      <th>Training Provider 1</th>
      <th>Upload Education Certificate 1</th>

      <th>From Year/Month 2</th>
      <th>To Year/Month 2</th>
      <th>Training Syllabus 2</th>
      <th>Training Course Title 2</th>
      <th>Duration (Hours) 2</th>
      <th>Training Provider 2</th>
      <th>Upload Education Certificate 2</th>

      <th>From Year/Month 3</th>
      <th>To Year/Month 3</th>
      <th>Training Syllabus 3</th>
      <th>Training Course Title 3</th>
      <th>Duration (Hours) 3</th>
      <th>Training Provider 3</th>
      <th>Upload Education Certificate 3</th>

      <th>Skill 1</th>
      <th>Percentage 1</th>

      <th>Skill 2</th>
      <th>Percentage 2</th>

      <th>Skill 3</th>
      <th>Percentage 3</th>

      <th>Title 1</th>
      <th>Date 1</th>
      <th>Publisher 1</th>
      <th>Link 1</th>

      <th>Title 2</th>
      <th>Date 2</th>
      <th>Publisher 2</th>
      <th>Link 2</th>

      <th>Title 3</th>
      <th>Date 3</th>
      <th>Publisher 3</th>
      <th>Link 3</th>

      <th>Document Group 1</th>
      <th>Document Title 1</th>
      <th>Revision Number 1</th>
      <th>Approver 1</th>


      <th>Document Group 2</th>
      <th>Document Title 2</th>
      <th>Revision Number 2</th>
      <th>Approver 2</th>


      <th>Document Group 3</th>
      <th>Document Title 3</th>
      <th>Revision Number 3</th>
      <th>Approver 3</th>

    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let item of DataList_Persone_Excel|filter:Filter_title:'fullname'">
      <td>{{DataList_Persone_Excel.indexOf(item)+1}}</td>

      <td>{{item.fname}}</td>
      <td>{{item.lname}}</td>
      <td>{{item.sex}}</td>
      <td>{{item.vaziat_Tahol}}</td>
      <td>{{item.mahal_tavalod}}</td>
      <td>{{item.shomareh_Shenasnameh}}</td>
      <td>{{item.shomareh_Shenasnameh_Seri}}</td>
      <td>{{item.codeMeli}}</td>
      <td>{{item.shomareh_bimeh}}</td>
      <td>{{item.name_Pedar}}</td>
      <td>{{item.shoghleh_Pedar}}</td>
      <td>{{item.shomareh_Hamreh}}</td>
      <td>{{item.maskan}}</td>
      <td>{{item.email}}</td>
      <td>{{item.address_Manzel}}</td>
      <td>{{item.codeposti}}</td>
      <td>{{item.tel}}</td>
      <td>{{item.vaziat_Nazam_Vazifeh}}</td>
      <td>{{item.vaziat_Nazam_Vazifeh_Dsc}}</td>
      <td>{{item.vaziat_startDate}} - {{item.vaziat_endDate}}</td>
      <td>{{item.name_Hamsar}}</td>
      <td>{{item.tedadFarzandan}}</td>
      <td>{{item.codeMeli_Hamsar}}</td>
      <td>{{item.shomareh_hamrah_Hamsar}}</td>
      <td>{{item.tahsilat_Hamsar}}</td>
      <td>{{item.tarikh_Tavalod_Hamsar}}</td>
      <td>{{item.shoghleh_Hamsar}}</td>


      <td>{{item.date_starrt1}}</td>
      <td>{{item.date_end1}}</td>
      <td>{{item.degree1}}</td>
      <td>{{item.reshteh1}}</td>
      <td>{{item.grayesh1}}</td>
      <td>{{item.uni1}}</td>
      <td>{{item.moadel1}}</td>
      <td>{{item.image1}}</td>

      <td>{{item.date_starrt2}}</td>
      <td>{{item.date_end2}}</td>
      <td>{{item.degree2}}</td>
      <td>{{item.reshteh2}}</td>
      <td>{{item.grayesh2}}</td>
      <td>{{item.uni2}}</td>
      <td>{{item.moadel2}}</td>
      <td>{{item.image2}}</td>

      <td>{{item.date_starrt3}}</td>
      <td>{{item.date_end3}}</td>
      <td>{{item.degree3}}</td>
      <td>{{item.reshteh3}}</td>
      <td>{{item.grayesh3}}</td>
      <td>{{item.uni3}}</td>
      <td>{{item.moadel3}}</td>
      <td>{{item.image3}}</td>

      <td>{{item.date_starrtKari1}}</td>
      <td>{{item.date_endKari1}}</td>
      <td>{{item.companyNameKari1}}</td>
      <td>{{item.typeKari1}}</td>
      <td>{{item.sematKari1}}</td>
      <td>{{item.leaveKari1}}</td>
      <td>{{item.telKari1}}</td>
      <td>{{item.addressKari1}}</td>

      <td>{{item.date_starrtKari2}}</td>
      <td>{{item.date_endKari2}}</td>
      <td>{{item.companyNameKari2}}</td>
      <td>{{item.typeKari2}}</td>
      <td>{{item.sematKari2}}</td>
      <td>{{item.leaveKari2}}</td>
      <td>{{item.telKari2}}</td>
      <td>{{item.addressKari2}}</td>

      <td>{{item.date_starrtKari3}}</td>
      <td>{{item.date_endKari3}}</td>
      <td>{{item.companyNameKari3}}</td>
      <td>{{item.typeKari3}}</td>
      <td>{{item.sematKari3}}</td>
      <td>{{item.leaveKari3}}</td>
      <td>{{item.telKari3}}</td>
      <td>{{item.addressKari3}}</td>

      <td>{{item.date_starrtAmoozeshi1}}</td>
      <td>{{item.date_endAmoozeshi1}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi1}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi1}}</td>
      <td>{{item.modatAmoozeshi1}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi1}}</td>
      <td>{{item.imageAmoozeshi1}}</td>

      <td>{{item.date_starrtAmoozeshi2}}</td>
      <td>{{item.date_endAmoozeshi2}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi2}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi2}}</td>
      <td>{{item.modatAmoozeshi2}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi2}}</td>
      <td>{{item.imageAmoozeshi2}}</td>

      <td>{{item.date_starrtAmoozeshi3}}</td>
      <td>{{item.date_endAmoozeshi3}}</td>
      <td>{{item.sarFaslAmozeshi_idAmoozeshi3}}</td>
      <td>{{item.dorehAmoozeshi_idAmoozeshi3}}</td>
      <td>{{item.modatAmoozeshi3}}</td>
      <td>{{item.bargozarKonnadehAmoozeshi3}}</td>
      <td>{{item.imageAmoozeshi3}}</td>

      <td>{{item.skill_id1}}</td>
      <td>{{item.percennt1}}</td>

      <td>{{item.skill_id2}}</td>
      <td>{{item.percennt2}}</td>

      <td>{{item.skill_id3}}</td>
      <td>{{item.percennt3}}</td>

      <td>{{item.title1}}</td>
      <td>{{item.tarikh1}}</td>
      <td>{{item.nasher1}}</td>
      <td>{{item.link1}}</td>

      <td>{{item.title2}}</td>
      <td>{{item.tarikh2}}</td>
      <td>{{item.nasher2}}</td>
      <td>{{item.link2}}</td>

      <td>{{item.title3}}</td>
      <td>{{item.tarikh3}}</td>
      <td>{{item.nasher3}}</td>
      <td>{{item.link3}}</td>


      <td>{{item.grpDoc_id1}}</td>
      <td>{{item.tlDoc_id1}}</td>
      <td>{{item.shomareh1}}</td>
      <td>{{item.taminKonandeh1}}</td>

      <td>{{item.grpDoc_id2}}</td>
      <td>{{item.tlDoc_id2}}</td>
      <td>{{item.shomareh2}}</td>
      <td>{{item.taminKonandeh2}}</td>

      <td>{{item.grpDoc_id3}}</td>
      <td>{{item.tlDoc_id3}}</td>
      <td>{{item.shomareh3}}</td>
      <td>{{item.taminKonandeh3}}</td>

    </tr>
  </tbody>
</table>